import React from 'react'
import RequestDesc from '../../Components/DashboardCom/RequestDesc'
import DashHeader from '../../Components/DashboardCom/Header/DashHeader'
import Footer from '../../Components/Footer/Footer'
const DashRequestDes = () => {
  return (
    <div>
      <DashHeader />  
      <RequestDesc />
      {/* <Footer />  */}
    </div>
  )
}

export default DashRequestDes